import React from 'react';
import { motion } from 'framer-motion';
import MagneticEffect from './MagneticEffect';

const Button = ({ children, variant = 'gold', className = '', onClick, type = 'button' }) => {
  const base = "relative overflow-hidden px-10 py-5 rounded-sm font-sans tracking-widest uppercase text-xs md:text-sm transition-all duration-700 flex items-center justify-center group";

  const variants = {
    gold: "bg-gold-gradient text-dark font-bold border border-transparent",
    wine: "bg-wine text-cream hover:bg-wine-light",
    outline: "border border-gold/40 text-gold hover:bg-gold/5 hover:border-gold",
    ghost: "text-cream hover:text-gold"
  };

  const glows = {
    gold: { boxShadow: '0 0 0px rgba(212,175,55,0)' },
    goldHover: { boxShadow: '0 0 25px rgba(212,175,55,0.5), 0 0 60px rgba(212,175,55,0.2), inset 0 0 20px rgba(212,175,55,0.1)' },
    outline: { boxShadow: '0 0 0px rgba(212,175,55,0)' },
    outlineHover: { boxShadow: '0 0 20px rgba(212,175,55,0.3), 0 0 50px rgba(212,175,55,0.1)' },
  };

  return (
    <MagneticEffect strength={0.35}>
      <motion.button
        type={type}
        onClick={onClick}
        initial={variant === 'gold' ? glows.gold : variant === 'outline' ? glows.outline : {}}
        whileHover={variant === 'gold' ? { ...glows.goldHover, scale: 1.04 } : variant === 'outline' ? { ...glows.outlineHover, scale: 1.04 } : { scale: 1.04 }}
        whileTap={{ scale: 0.97 }}
        transition={{ duration: 0.4 }}
        className={`${base} ${variants[variant]} ${className}`}
      >
        <span className="relative z-10">{children}</span>
        {/* Shimmer sweep */}
        {(variant === 'gold' || variant === 'outline') && (
          <div className="absolute inset-0 h-full w-full bg-white/15 translate-x-[-110%] skew-x-[-20deg] group-hover:translate-x-[200%] transition-transform duration-1000 ease-in-out" />
        )}
      </motion.button>
    </MagneticEffect>
  );
};

export default Button;